import Typography from "@mui/material/Typography";

import { misc } from "app/themes/colors";

type HighlightedProps = {
  highlighted?: boolean;
  children: React.ReactNode;
};
export default function Highlighted({
  highlighted,
  children
}: HighlightedProps) {
  return (
    <Typography
      fontSize="15px"
      lineHeight={1.3}
      p={1}
      borderRadius="4px"
      sx={{ background: highlighted ? misc.highlightPurple : undefined }}
    >
      {children}
    </Typography>
  );
}
